import React from 'react';

import { useField } from 'formik';
import { TextField } from '@mui/material';

interface Props {
  name: string;
  min: number;
  max: number;
  disabled?: boolean;
  value?: any;
}

const TextFieldWrapper = ({
  name,
  min,
  max,
  disabled,
  value,
}: Props): JSX.Element => {
  const [field, meta] = useField<{}>(name);

  return (
    <TextField
      name={name}
      type='number'
      InputProps={{
        inputProps: {
          max,
          min,
        },
      }}
      value={value}
      disabled={disabled}
      onChange={field.onChange}
      error={!!(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
    />
  );
};

export default TextFieldWrapper;
